export default "__VITE_ASSET__Byu6KorE__"